import React from "react";
import { transformUnit } from "../../helpers";
import { lbs, lbsCode, oz, ozCode } from "./consts";

export const WeightTransformer = ({ className = "", isOz, isLbs, weight }) => {
    return (
        <>
            {isOz && (
                <div className={`flex justify-content-end ${className}`}>
                    <span>
                        <strong>Calculated weight: </strong>
                        {transformUnit(weight, lbs).toFixed(2)} {lbsCode}
                    </span>
                </div>
            )}
            {isLbs && (
                <div className={`flex justify-content-end ${className}`}>
                    <span>
                        <strong>Calculated weight: </strong>
                        {transformUnit(weight, oz).toFixed(2)} {ozCode}
                    </span>
                </div>
            )}
        </>
    );
};
